import './BlockRadioList.scss';

import React, { FunctionComponent } from 'react';

import { AllFormData } from '../../../types/givingCheckoutForm';
import classNames from 'classnames';
import { useFormContext } from 'react-hook-form';

type BlockRadioProps = {
  name: keyof AllFormData;
  direction?: 'row' | 'column';
  items: RadioItem[];
};

type RadioItem = {
  title: string;
  value: string;
  defaultChecked?: boolean;
  description?: string;
  disabled?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
};

const BlockRadioList: FunctionComponent<BlockRadioProps> = ({
  name,
  direction = 'row',
  items,
}) => {
  const { register } = useFormContext<AllFormData>();

  return (
    <div
      className={classNames({
        'block-radio-list': true,
        'block-radio-list-row': direction === 'row',
      })}
    >
      {items.map(
        ({ value, defaultChecked, title, description, disabled }, index) => (
          <React.Fragment key={`${name}_${value}`}>
            <input
              id={`${name}_${index}`}
              data-qa={`radio-${name}-${value}`}
              type="radio"
              value={value}
              defaultChecked={defaultChecked}
              className="block-radio-input jg-sr-only"
              disabled={disabled}
              {...register(name)}
            />
            <label
              htmlFor={`${name}_${index}`}
              className={classNames('block-radio-item', {
                'block-radio-item-disabled': disabled,
              })}
              key={`${name}${value}`}
            >
              <div
                className={classNames('block-radio-item-title', {
                  'block-radio-item-title-disabled': disabled,
                })}
              >
                {title}
              </div>
              <span
                className={classNames({
                  'block-radio-item-description-disabled': disabled,
                })}
              >
                {description}
              </span>
            </label>
          </React.Fragment>
        ),
      )}
    </div>
  );
};

export default BlockRadioList;
